import React from "react";

function Home() {
  return (
    <div>
      <h1>Welcome to the Electronics App</h1>
    </div>
  );
}

export default Home;
